// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flip-list-move{-webkit-transition:all 1s;transition:all 1s}", ""]);
// Exports
module.exports = exports;
